import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RfqCreationService {

  constructor(
    private http: HttpClient
  ) { }


  addRfq(rfqForm: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/addRfq`;
    return this.http.post(url, rfqForm);
  }


  getRFQDefaultSetting(params: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/getRFQDefaultSetting`;
    return this.http.post(url, params);
  }


}
